import React, { useState, useEffect, useRef } from 'react'
import { supabase } from '../lib/supabase'
import toast from 'react-hot-toast'

const CMS_STYLES = `
  .rcms-tabs { display:flex; gap:0; border-bottom:2px solid #E8E6DF; margin-bottom:24px; flex-wrap:wrap; }
  .rcms-tab { padding:10px 18px; font-size:13px; font-weight:600; cursor:pointer; border:none; background:none; color:#7A7870; border-bottom:3px solid transparent; margin-bottom:-2px; transition:all 0.15s; font-family:inherit; white-space:nowrap; }
  .rcms-tab:hover { color:#0D1B3E; }
  .rcms-tab.active { color:#0D1B3E; border-bottom-color:#C9A84C; }
  .rcms-card { background:#fff; border:1px solid #E8E6DF; border-radius:14px; overflow:hidden; margin-bottom:14px; }
  .rcms-card-header { display:flex; align-items:center; justify-content:space-between; padding:14px 18px; background:#F8F7F4; border-bottom:1px solid #E8E6DF; flex-wrap:wrap; gap:8px; }
  .rcms-card-title { font-size:13px; font-weight:600; color:#0D1B3E; }
  .rcms-card-body { padding:18px; }
  .rcms-form { display:flex; flex-direction:column; gap:12px; }
  .rcms-label { font-size:11px; font-weight:600; color:#7A7870; letter-spacing:0.06em; margin-bottom:4px; display:block; }
  .rcms-input { width:100%; padding:10px 12px; border:1.5px solid #E0D9CC; border-radius:8px; font-size:13px; font-family:inherit; transition:border-color 0.15s; box-sizing:border-box; }
  .rcms-input:focus { outline:none; border-color:#C9A84C; }
  .rcms-textarea { width:100%; padding:10px 12px; border:1.5px solid #E0D9CC; border-radius:8px; font-size:13px; font-family:inherit; resize:vertical; min-height:100px; transition:border-color 0.15s; box-sizing:border-box; line-height:1.7; }
  .rcms-textarea:focus { outline:none; border-color:#C9A84C; }
  .rcms-select { width:100%; padding:10px 12px; border:1.5px solid #E0D9CC; border-radius:8px; font-size:13px; font-family:inherit; background:#fff; box-sizing:border-box; }
  .rcms-select:focus { outline:none; border-color:#C9A84C; }
  .rcms-row { display:flex; align-items:flex-start; justify-content:space-between; gap:12px; padding:14px 18px; border-bottom:1px solid #F0EEE8; flex-wrap:wrap; }
  .rcms-row:last-child { border-bottom:none; }
  .rcms-row:hover { background:#FAFAF8; }
  .rcms-badge-pub { background:#EAF5EE; color:#2D7A4F; font-size:10px; font-weight:600; padding:2px 8px; border-radius:10px; }
  .rcms-badge-draft { background:#F8F7F4; color:#B8B5AB; font-size:10px; font-weight:600; padding:2px 8px; border-radius:10px; border:1px solid #E8E6DF; }
  .rcms-badge-cat { background:#EEF2FF; color:#4B5EAA; font-size:10px; font-weight:600; padding:2px 8px; border-radius:10px; }
  .rcms-btn-icon { background:none; border:none; cursor:pointer; padding:4px 8px; border-radius:6px; font-size:14px; transition:background 0.15s; }
  .rcms-btn-icon:hover { background:#F0EEE8; }
  .rcms-empty { text-align:center; padding:40px 20px; color:#B8B5AB; }
  .rcms-empty-icon { font-size:40px; margin-bottom:12px; }
  .rcms-empty-text { font-size:13px; }
  .rcms-grid-2 { display:grid; grid-template-columns:1fr 1fr; gap:12px; }
  .rcms-grid-3 { display:grid; grid-template-columns:1fr 1fr 1fr; gap:12px; }
  @media(max-width:600px){ .rcms-grid-2,.rcms-grid-3 { grid-template-columns:1fr; } }
  .rcms-filter-row { display:flex; gap:8px; padding:12px 18px; border-bottom:1px solid #E8E6DF; flex-wrap:wrap; }
  .rcms-filter-btn { padding:5px 14px; border-radius:20px; font-size:11px; font-weight:600; border:1.5px solid #E0D9CC; background:#fff; color:#7A7870; cursor:pointer; transition:all 0.15s; font-family:inherit; white-space:nowrap; }
  .rcms-filter-btn.active { background:#0D1B3E; color:#C9A84C; border-color:#0D1B3E; }
  .rcms-filter-btn:hover { border-color:#C9A84C; color:#0D1B3E; }
  .rcms-state-row { display:flex; align-items:center; gap:10px; padding:10px 16px; border-bottom:1px solid #F0EEE8; flex-wrap:wrap; }
  .rcms-state-row:last-child { border-bottom:none; }
  .rcms-state-code { font-size:12px; font-weight:700; color:#0D1B3E; min-width:28px; }
  .rcms-state-name { font-size:12px; color:#4A4840; min-width:120px; }
  .rcms-state-url { font-size:11px; color:#9A7A30; text-decoration:none; flex:1; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
  .rcms-state-url:hover { text-decoration:underline; }
  .rcms-upload-zone { border:2px dashed #E0D9CC; border-radius:10px; padding:24px; text-align:center; cursor:pointer; transition:all 0.15s; background:#FAFAF8; }
  .rcms-upload-zone:hover { border-color:#C9A84C; background:#FFFBF0; }
  .rcms-doc-row { display:flex; align-items:center; gap:12px; padding:12px 18px; border-bottom:1px solid #F0EEE8; flex-wrap:wrap; }
  .rcms-doc-row:last-child { border-bottom:none; }
  .rcms-doc-row:hover { background:#FAFAF8; }
  .rcms-doc-icon { width:36px; height:36px; border-radius:8px; display:flex; align-items:center; justify-content:center; font-size:18px; flex-shrink:0; background:#F0EEE8; }
  .rcms-state-card { border:1px solid #E8E6DF; border-radius:12px; margin-bottom:10px; overflow:hidden; }
  .rcms-state-card-head { display:flex; align-items:center; gap:10px; padding:12px 16px; background:#FAFAF8; cursor:pointer; flex-wrap:wrap; }
  .rcms-state-card-head:hover { background:#F0EEE8; }
  .rcms-state-card-body { padding:16px; border-top:1px solid #E8E6DF; background:#fff; }
  .rcms-data-badge { font-size:9px; font-weight:700; padding:2px 8px; border-radius:10px; letter-spacing:0.05em; }
  .rcms-data-badge.full { background:#EAF5EE; color:#2D7A4F; }
  .rcms-data-badge.partial { background:#FDF6E3; color:#8A5C00; border:1px solid #C9A84C; }
  .rcms-data-badge.empty { background:#F8F7F4; color:#B8B5AB; border:1px solid #E8E6DF; }
`

const US_STATES = [
  ['AL','Alabama'],['AK','Alaska'],['AZ','Arizona'],['AR','Arkansas'],
  ['CA','California'],['CO','Colorado'],['CT','Connecticut'],['DE','Delaware'],
  ['FL','Florida'],['GA','Georgia'],['HI','Hawaii'],['ID','Idaho'],
  ['IL','Illinois'],['IN','Indiana'],['IA','Iowa'],['KS','Kansas'],
  ['KY','Kentucky'],['LA','Louisiana'],['ME','Maine'],['MD','Maryland'],
  ['MA','Massachusetts'],['MI','Michigan'],['MN','Minnesota'],['MS','Mississippi'],
  ['MO','Missouri'],['MT','Montana'],['NE','Nebraska'],['NV','Nevada'],
  ['NH','New Hampshire'],['NJ','New Jersey'],['NM','New Mexico'],['NY','New York'],
  ['NC','North Carolina'],['ND','North Dakota'],['OH','Ohio'],['OK','Oklahoma'],
  ['OR','Oregon'],['PA','Pennsylvania'],['RI','Rhode Island'],['SC','South Carolina'],
  ['SD','South Dakota'],['TN','Tennessee'],['TX','Texas'],['UT','Utah'],
  ['VT','Vermont'],['VA','Virginia'],['WA','Washington'],['WV','West Virginia'],
  ['WI','Wisconsin'],['WY','Wyoming'],
]

const GLOSSARY_CATEGORIES = [
  'Notary Fundamentals',
  'Notarial Certificates',
  'Signing Agent Terms',
  'Mortgage & Loan Terms',
  'Real Estate Terms',
  'Apostille & Authentication Terms',
  'Estate Planning Terms',
  'Identity & Business Terms',
  'General',
]

const DOC_CATEGORIES = ['Notarial Certificates','Loan Signing Documents','Study Guides','Notary Business','Miscellaneous']

// Fields shown when editing a state — keep order consistent everywhere
const STATE_DATA_FIELDS = [
  { key:'max_notary_fee',      label:'💰 Max Notary Fee',              placeholder:'e.g. $10 per signature' },
  { key:'ron_status',           label:'🖥️ RON Status',                  placeholder:'e.g. Allowed for in-state signers only' },
  { key:'journal_required',     label:'📓 Journal Required',            placeholder:'e.g. Yes — required for all notarial acts' },
  { key:'attorney_closing',     label:'⚖️ Attorney Closing State',      placeholder:'e.g. Yes — attorney must conduct closing' },
  { key:'travel_fee_guidance',  label:'🚗 Travel Fee Guidance',         placeholder:'e.g. No cap; mileage typical' },
  { key:'bond_requirements',    label:'📜 E&O or Bond Requirements',    placeholder:'e.g. $7,500 surety bond and/or E&O insurance' },
  { key:'commission_term',      label:'⏰ Commission Term',              placeholder:'e.g. 4 years' },
  { key:'wedding_ceremonies',   label:'💍 Perform Wedding Ceremonies',  placeholder:'e.g. Yes — notaries authorized to officiate' },
  { key:'special_notes',        label:'📝 Special Notes',               placeholder:'Anything else worth knowing...', isTextarea:true },
]

// ── GLOSSARY TAB ──────────────────────────────────────────────
function GlossaryTab() {
  const [terms,    setTerms]    = useState([])
  const [loading,  setLoading]  = useState(true)
  const [editing,  setEditing]  = useState(null)
  const [form,     setForm]     = useState({ term:'', definition:'', category:'Notary Fundamentals', sort_order:0, published:true })
  const [saving,   setSaving]   = useState(false)
  const [filterCat,setFilterCat]= useState('All')
  const [search,   setSearch]   = useState('')

  useEffect(() => { loadTerms() }, [])

  async function loadTerms() {
    const { data } = await supabase.from('resources_glossary').select('*')
      .order('category', { ascending: true }).order('sort_order', { ascending: true }).order('term', { ascending: true })
    setTerms(data || []); setLoading(false)
  }

  function openNew() { setForm({ term:'', definition:'', category: filterCat !== 'All' ? filterCat : 'Notary Fundamentals', sort_order:0, published:true }); setEditing('new') }
  function openEdit(t) { setForm({ term:t.term, definition:t.definition, category:t.category||'General', sort_order:t.sort_order||0, published:t.published }); setEditing(t) }

  async function save() {
    if (!form.term.trim() || !form.definition.trim()) { toast.error('Term and definition are required!!'); return }
    setSaving(true)
    try {
      if (editing === 'new') {
        const { error } = await supabase.from('resources_glossary').insert({ term:form.term.trim(), definition:form.definition.trim(), category:form.category, sort_order:Number(form.sort_order)||0, published:form.published })
        if (error) throw error; toast.success('✅ Term added!!')
      } else {
        const { error } = await supabase.from('resources_glossary').update({ term:form.term.trim(), definition:form.definition.trim(), category:form.category, sort_order:Number(form.sort_order)||0, published:form.published }).eq('id', editing.id)
        if (error) throw error; toast.success('✅ Term updated!!')
      }
      setEditing(null); loadTerms()
    } catch (err) { toast.error(err.message) }
    finally { setSaving(false) }
  }

  async function togglePublished(t) { await supabase.from('resources_glossary').update({ published: !t.published }).eq('id', t.id); loadTerms() }
  async function deleteTerm(t) {
    if (!window.confirm(`Delete "${t.term}"?`)) return
    await supabase.from('resources_glossary').delete().eq('id', t.id)
    toast.success('Term deleted'); loadTerms()
  }

  const filtered = terms.filter(t => {
    const matchCat    = filterCat === 'All' || t.category === filterCat
    const matchSearch = !search || t.term.toLowerCase().includes(search.toLowerCase()) || t.definition.toLowerCase().includes(search.toLowerCase())
    return matchCat && matchSearch
  })

  const allCats = ['All', ...GLOSSARY_CATEGORIES]

  return (
    <>
      {editing && (
        <div className="rcms-card" style={{ marginBottom:20, border:'2px solid #C9A84C' }}>
          <div className="rcms-card-header">
            <span className="rcms-card-title">{editing === 'new' ? '➕ Add New Term' : `✏️ Edit: ${editing.term}`}</span>
            <button onClick={() => setEditing(null)} style={{ background:'none', border:'none', cursor:'pointer', color:'#B8B5AB', fontSize:16 }}>✕</button>
          </div>
          <div className="rcms-card-body">
            <div className="rcms-form">
              <div className="rcms-grid-3">
                <div><label className="rcms-label">TERM *</label><input className="rcms-input" placeholder="e.g. Notarization" value={form.term} onChange={e => setForm(f => ({ ...f, term:e.target.value }))} /></div>
                <div>
                  <label className="rcms-label">CATEGORY *</label>
                  <select className="rcms-select" value={form.category} onChange={e => setForm(f => ({ ...f, category:e.target.value }))}>
                    {GLOSSARY_CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}
                  </select>
                </div>
                <div><label className="rcms-label">SORT ORDER</label><input className="rcms-input" type="number" value={form.sort_order} onChange={e => setForm(f => ({ ...f, sort_order:e.target.value }))} /></div>
              </div>
              <div><label className="rcms-label">DEFINITION *</label><textarea className="rcms-textarea" placeholder="Write a clear definition..." value={form.definition} onChange={e => setForm(f => ({ ...f, definition:e.target.value }))} rows={4} /></div>
              <label style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer', fontSize:13, color:'#4A4840' }}>
                <input type="checkbox" checked={form.published} onChange={e => setForm(f => ({ ...f, published:e.target.checked }))} />
                Published (visible to notaries)
              </label>
              <div style={{ display:'flex', gap:10 }}>
                <button onClick={() => setEditing(null)} style={{ padding:'10px 20px', borderRadius:8, border:'1px solid #E0D9CC', background:'#fff', color:'#7A7870', cursor:'pointer', fontSize:13 }}>Cancel</button>
                <button onClick={save} disabled={saving} style={{ padding:'10px 24px', borderRadius:8, border:'none', background:'linear-gradient(135deg,#0D1B3E,#1A3A5E)', color:'#C9A84C', cursor:'pointer', fontWeight:600, fontSize:13, opacity:saving?0.6:1 }}>
                  {saving ? 'Saving...' : editing === 'new' ? '✅ Add Term' : '✅ Save Changes'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="rcms-card">
        <div className="rcms-card-header">
          <span className="rcms-card-title">📖 Glossary ({terms.filter(t=>t.published).length} published · {terms.length} total)</span>
          <div style={{ display:'flex', gap:8, alignItems:'center', flexWrap:'wrap' }}>
            <input className="rcms-input" placeholder="Search terms..." value={search} onChange={e => setSearch(e.target.value)} style={{ width:160, padding:'6px 12px', fontSize:12 }} />
            <button onClick={openNew} style={{ padding:'8px 16px', borderRadius:8, border:'none', background:'#0D1B3E', color:'#C9A84C', cursor:'pointer', fontWeight:600, fontSize:12, whiteSpace:'nowrap' }}>➕ Add Term</button>
          </div>
        </div>

        <div className="rcms-filter-row">
          {allCats.map(c => (
            <button key={c} type="button" className={`rcms-filter-btn${filterCat === c ? ' active' : ''}`} onClick={() => setFilterCat(c)}>
              {c}{c !== 'All' ? ` (${terms.filter(t => t.category === c).length})` : ` (${terms.length})`}
            </button>
          ))}
        </div>

        {loading ? <div style={{ textAlign:'center', padding:32, color:'#B8B5AB', fontSize:13 }}>Loading glossary...</div>
        : filtered.length === 0 ? <div className="rcms-empty"><div className="rcms-empty-icon">📖</div><div className="rcms-empty-text">No terms found!! Click "Add Term" to get started.</div></div>
        : filtered.map(t => (
          <div key={t.id} className="rcms-row">
            <div style={{ flex:1, minWidth:0 }}>
              <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:4, flexWrap:'wrap' }}>
                <span style={{ fontFamily:'Cormorant Garamond,serif', fontSize:16, fontWeight:600, color:'#0D1B3E' }}>{t.term}</span>
                <span className="rcms-badge-cat">{t.category || 'General'}</span>
                <span className={t.published ? 'rcms-badge-pub' : 'rcms-badge-draft'}>{t.published ? 'Published' : 'Draft'}</span>
              </div>
              <div style={{ fontSize:12, color:'#7A7870', lineHeight:1.6 }}>{t.definition}</div>
            </div>
            <div style={{ display:'flex', gap:4, flexShrink:0 }}>
              <button className="rcms-btn-icon" onClick={() => togglePublished(t)}>{t.published ? '👁️' : '🙈'}</button>
              <button className="rcms-btn-icon" onClick={() => openEdit(t)}>✏️</button>
              <button className="rcms-btn-icon" onClick={() => deleteTerm(t)} style={{ color:'#E24B4A' }}>🗑️</button>
            </div>
          </div>
        ))}
      </div>
    </>
  )
}

// ── TRAINING MANUAL TAB ───────────────────────────────────────
function TrainingManualTab() {
  const [chapters, setChapters] = useState([])
  const [loading,  setLoading]  = useState(true)
  const [editing,  setEditing]  = useState(null)
  const [form,     setForm]     = useState({ title:'', content:'', sort_order:0, published:true })
  const [saving,   setSaving]   = useState(false)
  const [expanded, setExpanded] = useState(null)

  useEffect(() => { loadChapters() }, [])

  async function loadChapters() {
    const { data } = await supabase.from('resources_chapters').select('*').order('sort_order', { ascending: true })
    setChapters(data || []); setLoading(false)
  }

  function openNew() { setForm({ title:'', content:'', sort_order: chapters.length + 1, published:true }); setEditing('new'); setExpanded(null) }
  function openEdit(c) { setForm({ title:c.title, content:c.content, sort_order:c.sort_order||0, published:c.published }); setEditing(c); setExpanded(null) }

  async function save() {
    if (!form.title.trim() || !form.content.trim()) { toast.error('Title and content are required!!'); return }
    setSaving(true)
    try {
      if (editing === 'new') {
        const { error } = await supabase.from('resources_chapters').insert({ title:form.title.trim(), content:form.content.trim(), sort_order:Number(form.sort_order)||0, published:form.published })
        if (error) throw error; toast.success('✅ Chapter added!!')
      } else {
        const { error } = await supabase.from('resources_chapters').update({ title:form.title.trim(), content:form.content.trim(), sort_order:Number(form.sort_order)||0, published:form.published }).eq('id', editing.id)
        if (error) throw error; toast.success('✅ Chapter updated!!')
      }
      setEditing(null); loadChapters()
    } catch (err) { toast.error(err.message) }
    finally { setSaving(false) }
  }

  async function togglePublished(c) { await supabase.from('resources_chapters').update({ published: !c.published }).eq('id', c.id); loadChapters() }
  async function deleteChapter(c) {
    if (!window.confirm(`Delete "${c.title}"?`)) return
    await supabase.from('resources_chapters').delete().eq('id', c.id)
    toast.success('Chapter deleted'); loadChapters()
  }

  return (
    <>
      {editing && (
        <div className="rcms-card" style={{ marginBottom:20, border:'2px solid #C9A84C' }}>
          <div className="rcms-card-header">
            <span className="rcms-card-title">{editing === 'new' ? '➕ Add New Chapter' : `✏️ Edit: ${editing.title}`}</span>
            <button onClick={() => setEditing(null)} style={{ background:'none', border:'none', cursor:'pointer', color:'#B8B5AB', fontSize:16 }}>✕</button>
          </div>
          <div className="rcms-card-body">
            <div className="rcms-form">
              <div className="rcms-grid-2">
                <div><label className="rcms-label">CHAPTER TITLE *</label><input className="rcms-input" placeholder="e.g. Understanding the Loan Package" value={form.title} onChange={e => setForm(f => ({ ...f, title:e.target.value }))} /></div>
                <div><label className="rcms-label">CHAPTER NUMBER</label><input className="rcms-input" type="number" value={form.sort_order} onChange={e => setForm(f => ({ ...f, sort_order:e.target.value }))} /></div>
              </div>
              <div>
                <label className="rcms-label">CONTENT *</label>
                <textarea className="rcms-textarea" placeholder="Write your chapter content here..." value={form.content} onChange={e => setForm(f => ({ ...f, content:e.target.value }))} rows={12} style={{ minHeight:200 }} />
                <div style={{ fontSize:10, color:'#B8B5AB', marginTop:4 }}>{form.content.length} characters</div>
              </div>
              <label style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer', fontSize:13, color:'#4A4840' }}>
                <input type="checkbox" checked={form.published} onChange={e => setForm(f => ({ ...f, published:e.target.checked }))} />
                Published (visible to notaries)
              </label>
              <div style={{ display:'flex', gap:10 }}>
                <button onClick={() => setEditing(null)} style={{ padding:'10px 20px', borderRadius:8, border:'1px solid #E0D9CC', background:'#fff', color:'#7A7870', cursor:'pointer', fontSize:13 }}>Cancel</button>
                <button onClick={save} disabled={saving} style={{ padding:'10px 24px', borderRadius:8, border:'none', background:'linear-gradient(135deg,#0D1B3E,#1A3A5E)', color:'#C9A84C', cursor:'pointer', fontWeight:600, fontSize:13, opacity:saving?0.6:1 }}>
                  {saving ? 'Saving...' : editing === 'new' ? '✅ Add Chapter' : '✅ Save Changes'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="rcms-card">
        <div className="rcms-card-header">
          <span className="rcms-card-title">📋 Training Manual ({chapters.filter(c=>c.published).length} published)</span>
          <button onClick={openNew} style={{ padding:'8px 16px', borderRadius:8, border:'none', background:'#0D1B3E', color:'#C9A84C', cursor:'pointer', fontWeight:600, fontSize:12 }}>➕ Add Chapter</button>
        </div>
        {loading ? <div style={{ textAlign:'center', padding:32, color:'#B8B5AB', fontSize:13 }}>Loading...</div>
        : chapters.length === 0 ? <div className="rcms-empty"><div className="rcms-empty-icon">📋</div><div className="rcms-empty-text">No chapters yet!! Click "Add Chapter" to get started.</div></div>
        : chapters.map(c => (
          <div key={c.id} className="rcms-row" style={{ flexDirection:'column', alignItems:'stretch' }}>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', gap:12 }}>
              <div style={{ display:'flex', alignItems:'center', gap:10, flex:1, minWidth:0 }}>
                <span style={{ fontSize:13, fontWeight:700, color:'#C9A84C', minWidth:24 }}>{c.sort_order||'—'}</span>
                <button type="button" onClick={() => setExpanded(expanded===c.id?null:c.id)} style={{ background:'none', border:'none', cursor:'pointer', textAlign:'left', flex:1, padding:0 }}>
                  <span style={{ fontFamily:'Cormorant Garamond,serif', fontSize:16, fontWeight:600, color:'#0D1B3E' }}>{c.title}</span>
                </button>
                <span className={c.published?'rcms-badge-pub':'rcms-badge-draft'}>{c.published?'Published':'Draft'}</span>
              </div>
              <div style={{ display:'flex', gap:4, flexShrink:0 }}>
                <button className="rcms-btn-icon" onClick={() => togglePublished(c)}>{c.published?'👁️':'🙈'}</button>
                <button className="rcms-btn-icon" onClick={() => openEdit(c)}>✏️</button>
                <button className="rcms-btn-icon" onClick={() => deleteChapter(c)} style={{ color:'#E24B4A' }}>🗑️</button>
              </div>
            </div>
            {expanded===c.id && <div style={{ marginTop:10, background:'#F8F7F4', borderRadius:8, padding:'12px 14px', fontSize:12, lineHeight:1.8, color:'#4A4840', whiteSpace:'pre-line' }}>{c.content}</div>}
          </div>
        ))}
      </div>
    </>
  )
}

// ── STATE RESOURCES TAB — EXPANDED EDITOR ────────────────────
function StateResourcesTab() {
  const [states,   setStates]   = useState([])
  const [loading,  setLoading]  = useState(true)
  const [editing,  setEditing]  = useState(null) // state_code being edited
  const [form,     setForm]     = useState({})
  const [saving,   setSaving]   = useState(false)
  const [search,   setSearch]   = useState('')
  const [filter,   setFilter]   = useState('all') // all | with-data | without-data

  useEffect(() => { loadStates() }, [])

  async function loadStates() {
    setLoading(true)
    const { data } = await supabase.from('resources_states').select('*').order('state_code', { ascending: true })
    setStates(data || []); setLoading(false)
  }

  function openEdit(stateCode, stateName, saved) {
    const initial = { url:'', max_notary_fee:'', ron_status:'', journal_required:'', attorney_closing:'', travel_fee_guidance:'', bond_requirements:'', commission_term:'', wedding_ceremonies:'', special_notes:'' }
    if (saved) {
      STATE_DATA_FIELDS.forEach(f => { initial[f.key] = saved[f.key] || '' })
      initial.url = saved.url || ''
    }
    setForm(initial)
    setEditing(stateCode)
  }

  async function saveState(stateCode, stateName) {
    if (form.url && !form.url.startsWith('http')) {
      toast.error('URL must start with https://'); return
    }
    setSaving(true)
    try {
      const payload = { state_code:stateCode, state_name:stateName, published:true, updated_at:new Date().toISOString() }
      // Only set fields that are non-empty (or url which can be empty-string)
      payload.url = form.url?.trim() || null
      STATE_DATA_FIELDS.forEach(f => {
        payload[f.key] = form[f.key]?.trim() || null
      })
      const { error } = await supabase.from('resources_states').upsert(payload, { onConflict:'state_code' })
      if (error) throw error
      toast.success(`✅ ${stateName} saved!!`)
      setEditing(null); loadStates()
    } catch (err) {
      toast.error(err.message)
    } finally {
      setSaving(false)
    }
  }

  // Count how many data fields a state has filled in (out of STATE_DATA_FIELDS.length)
  function getDataLevel(saved) {
    if (!saved) return { count:0, total:STATE_DATA_FIELDS.length, level:'empty' }
    const count = STATE_DATA_FIELDS.filter(f => saved[f.key] && String(saved[f.key]).trim()).length
    let level = 'empty'
    if (count === STATE_DATA_FIELDS.length) level = 'full'
    else if (count > 0) level = 'partial'
    return { count, total:STATE_DATA_FIELDS.length, level }
  }

  const stateMap = {}
  states.forEach(s => { stateMap[s.state_code] = s })

  const filtered = US_STATES.filter(([code, name]) => {
    const matchSearch = !search || name.toLowerCase().includes(search.toLowerCase()) || code.toLowerCase().includes(search.toLowerCase())
    if (!matchSearch) return false
    const { level } = getDataLevel(stateMap[code])
    if (filter === 'with-data') return level !== 'empty'
    if (filter === 'without-data') return level === 'empty'
    return true
  })

  const totalWithData = US_STATES.filter(([code]) => getDataLevel(stateMap[code]).level !== 'empty').length

  return (
    <div className="rcms-card">
      <div className="rcms-card-header">
        <span className="rcms-card-title">🗺️ State Notary Websites & Regulations ({totalWithData}/50 with data)</span>
        <input className="rcms-input" placeholder="Search state..." value={search} onChange={e => setSearch(e.target.value)} style={{ width:180, padding:'6px 12px', fontSize:12 }} />
      </div>

      <div className="rcms-filter-row">
        {[
          { key:'all', label:`All States (${US_STATES.length})` },
          { key:'with-data', label:`✅ With Data (${totalWithData})` },
          { key:'without-data', label:`⚪ No Data Yet (${US_STATES.length - totalWithData})` },
        ].map(f => (
          <button key={f.key} type="button" className={`rcms-filter-btn${filter === f.key ? ' active' : ''}`} onClick={() => setFilter(f.key)}>{f.label}</button>
        ))}
      </div>

      {loading && <div style={{ textAlign:'center', padding:32, color:'#B8B5AB', fontSize:13 }}>Loading...</div>}

      {!loading && filtered.length === 0 && (
        <div className="rcms-empty"><div className="rcms-empty-icon">🗺️</div><div className="rcms-empty-text">No states match that filter.</div></div>
      )}

      {!loading && filtered.map(([code, name]) => {
        const saved = stateMap[code]
        const isEditing = editing === code
        const { count, total, level } = getDataLevel(saved)

        return (
          <div key={code} className="rcms-state-card" style={{ margin:'10px 16px' }}>
            <div className="rcms-state-card-head" onClick={() => !isEditing && openEdit(code, name, saved)}>
              <span className="rcms-state-code">{code}</span>
              <span style={{ flex:1, fontSize:13, fontWeight:600, color:'#0D1B3E', minWidth:120 }}>{name}</span>
              <span className={`rcms-data-badge ${level}`}>
                {level === 'full'    && `✅ COMPLETE`}
                {level === 'partial' && `📝 ${count}/${total} FIELDS`}
                {level === 'empty'   && `⚪ NO DATA`}
              </span>
              {saved?.url && (
                <a href={saved.url} target="_blank" rel="noreferrer" onClick={e=>e.stopPropagation()} style={{ fontSize:11, color:'#9A7A30', textDecoration:'none' }}>🔗 link</a>
              )}
              <button onClick={(e) => { e.stopPropagation(); isEditing ? setEditing(null) : openEdit(code, name, saved) }} style={{ background:'none', border:'1px solid #E8E6DF', borderRadius:6, cursor:'pointer', padding:'4px 10px', fontSize:11, color:'#7A7870' }}>
                {isEditing ? '✕ Close' : (saved ? '✏️ Edit' : '➕ Add Data')}
              </button>
            </div>

            {isEditing && (
              <div className="rcms-state-card-body">
                <div className="rcms-form">
                  <div>
                    <label className="rcms-label">🔗 STATE COMMISSION WEBSITE</label>
                    <input className="rcms-input" placeholder="https://..." value={form.url || ''} onChange={e => setForm(f => ({ ...f, url:e.target.value }))} />
                  </div>
                  <div className="rcms-grid-2">
                    {STATE_DATA_FIELDS.map(f => (
                      f.isTextarea ? (
                        <div key={f.key} style={{ gridColumn:'1/-1' }}>
                          <label className="rcms-label">{f.label.toUpperCase()}</label>
                          <textarea className="rcms-textarea" placeholder={f.placeholder} value={form[f.key] || ''} onChange={e => setForm(fm => ({ ...fm, [f.key]:e.target.value }))} rows={3} style={{ minHeight:80 }} />
                        </div>
                      ) : (
                        <div key={f.key}>
                          <label className="rcms-label">{f.label.toUpperCase()}</label>
                          <input className="rcms-input" placeholder={f.placeholder} value={form[f.key] || ''} onChange={e => setForm(fm => ({ ...fm, [f.key]:e.target.value }))} />
                        </div>
                      )
                    ))}
                  </div>
                  <div style={{ display:'flex', gap:10 }}>
                    <button onClick={() => setEditing(null)} style={{ padding:'10px 20px', borderRadius:8, border:'1px solid #E0D9CC', background:'#fff', color:'#7A7870', cursor:'pointer', fontSize:13 }}>Cancel</button>
                    <button onClick={() => saveState(code, name)} disabled={saving} style={{ padding:'10px 24px', borderRadius:8, border:'none', background:'linear-gradient(135deg,#0D1B3E,#1A3A5E)', color:'#C9A84C', cursor:'pointer', fontWeight:600, fontSize:13, opacity:saving?0.6:1 }}>
                      {saving ? 'Saving...' : `✅ Save ${name}`}
                    </button>
                  </div>
                  <div style={{ fontSize:10, color:'#B8B5AB', fontStyle:'italic' }}>💡 Leave any field blank — your tribe will just see the ones you've filled in!!</div>
                </div>
              </div>
            )}
          </div>
        )
      })}
    </div>
  )
}

// ── DOCUMENT LIBRARY TAB ──────────────────────────────────────
function DocumentLibraryTab() {
  const [docs,      setDocs]      = useState([])
  const [loading,   setLoading]   = useState(true)
  const [uploading, setUploading] = useState(false)
  const [editing,   setEditing]   = useState(null)
  const [form,      setForm]      = useState({ name:'', description:'', category:'Notarial Certificates', sort_order:0, published:true })
  const [saving,    setSaving]    = useState(false)
  const fileRef = useRef(null)

  useEffect(() => { loadDocs() }, [])

  async function loadDocs() {
    const { data } = await supabase.from('resources_documents').select('*').order('sort_order',{ascending:true}).order('created_at',{ascending:false})
    setDocs(data||[]); setLoading(false)
  }

  async function uploadFile(file) {
    if (!file) return null
    setUploading(true)
    try {
      const path = `library/${Date.now()}-${file.name.replace(/[^a-zA-Z0-9.-]/g,'_')}`
      const { error } = await supabase.storage.from('resources').upload(path, file, { upsert:false })
      if (error) throw error
      const { data:{ publicUrl } } = supabase.storage.from('resources').getPublicUrl(path)
      return { url:publicUrl, type:file.type, size:file.size }
    } catch (err) { toast.error('Upload failed: '+err.message); return null }
    finally { setUploading(false) }
  }

  async function handleFileSelect(e) {
    const file = e.target.files[0]
    if (!file) return
    const name = file.name.replace(/\.[^.]+$/,'').replace(/[-_]/g,' ')
    setForm(f => ({ ...f, name: f.name || name }))
    const uploaded = await uploadFile(file)
    if (!uploaded) return
    const { error } = await supabase.from('resources_documents').insert({ name:form.name||name, description:form.description||null, category:form.category, file_url:uploaded.url, file_type:uploaded.type, file_size:uploaded.size, sort_order:Number(form.sort_order)||0, published:form.published })
    if (error) { toast.error(error.message); return }
    toast.success('✅ Document uploaded!!'); e.target.value=''; loadDocs()
  }

  async function saveEdit() {
    if (!form.name.trim()) { toast.error('Name is required!!'); return }
    setSaving(true)
    try {
      const { error } = await supabase.from('resources_documents').update({ name:form.name.trim(), description:form.description||null, category:form.category, sort_order:Number(form.sort_order)||0, published:form.published }).eq('id', editing.id)
      if (error) throw error
      toast.success('✅ Updated!!'); setEditing(null); loadDocs()
    } catch (err) { toast.error(err.message) }
    finally { setSaving(false) }
  }

  async function togglePublished(d) { await supabase.from('resources_documents').update({ published:!d.published }).eq('id',d.id); loadDocs() }
  async function deleteDoc(d) {
    if (!window.confirm(`Delete "${d.name}"?`)) return
    await supabase.from('resources_documents').delete().eq('id',d.id)
    toast.success('Document deleted'); loadDocs()
  }

  return (
    <>
      <div className="rcms-card" style={{ marginBottom:20 }}>
        <div className="rcms-card-header"><span className="rcms-card-title">📤 Upload New Document</span></div>
        <div className="rcms-card-body">
          <div className="rcms-form">
            <div className="rcms-grid-2">
              <div><label className="rcms-label">DOCUMENT NAME</label><input className="rcms-input" placeholder="e.g. Florida Notarial Certificate Sample" value={form.name} onChange={e => setForm(f=>({...f,name:e.target.value}))} /></div>
              <div><label className="rcms-label">CATEGORY</label><select className="rcms-select" value={form.category} onChange={e => setForm(f=>({...f,category:e.target.value}))}>{DOC_CATEGORIES.map(c=><option key={c} value={c}>{c}</option>)}</select></div>
            </div>
            <div><label className="rcms-label">DESCRIPTION (optional)</label><input className="rcms-input" placeholder="Brief description..." value={form.description} onChange={e => setForm(f=>({...f,description:e.target.value}))} /></div>
            <label style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer', fontSize:13, color:'#4A4840' }}>
              <input type="checkbox" checked={form.published} onChange={e => setForm(f=>({...f,published:e.target.checked}))} />
              Published immediately
            </label>
            <div>
              <input ref={fileRef} type="file" accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.ppt,.pptx" style={{ display:'none' }} onChange={handleFileSelect} />
              <div className="rcms-upload-zone" onClick={() => fileRef.current?.click()}>
                {uploading ? <div style={{ color:'#C9A84C', fontWeight:600 }}>⏳ Uploading...</div> : (
                  <><div style={{ fontSize:32, marginBottom:8 }}>📂</div><div style={{ fontSize:13, fontWeight:600, color:'#0D1B3E', marginBottom:4 }}>Click to upload a document</div><div style={{ fontSize:11, color:'#B8B5AB' }}>PDF, JPG, PNG, Word, PowerPoint</div></>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {editing && (
        <div className="rcms-card" style={{ marginBottom:20, border:'2px solid #C9A84C' }}>
          <div className="rcms-card-header">
            <span className="rcms-card-title">✏️ Edit: {editing.name}</span>
            <button onClick={() => setEditing(null)} style={{ background:'none', border:'none', cursor:'pointer', color:'#B8B5AB', fontSize:16 }}>✕</button>
          </div>
          <div className="rcms-card-body">
            <div className="rcms-form">
              <div className="rcms-grid-2">
                <div><label className="rcms-label">NAME *</label><input className="rcms-input" value={form.name} onChange={e => setForm(f=>({...f,name:e.target.value}))} /></div>
                <div><label className="rcms-label">CATEGORY</label><select className="rcms-select" value={form.category} onChange={e => setForm(f=>({...f,category:e.target.value}))}>{DOC_CATEGORIES.map(c=><option key={c} value={c}>{c}</option>)}</select></div>
              </div>
              <div><label className="rcms-label">DESCRIPTION</label><input className="rcms-input" value={form.description} onChange={e => setForm(f=>({...f,description:e.target.value}))} /></div>
              <label style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer', fontSize:13, color:'#4A4840' }}>
                <input type="checkbox" checked={form.published} onChange={e => setForm(f=>({...f,published:e.target.checked}))} />Published
              </label>
              <div style={{ display:'flex', gap:10 }}>
                <button onClick={() => setEditing(null)} style={{ padding:'10px 20px', borderRadius:8, border:'1px solid #E0D9CC', background:'#fff', color:'#7A7870', cursor:'pointer', fontSize:13 }}>Cancel</button>
                <button onClick={saveEdit} disabled={saving} style={{ padding:'10px 24px', borderRadius:8, border:'none', background:'linear-gradient(135deg,#0D1B3E,#1A3A5E)', color:'#C9A84C', cursor:'pointer', fontWeight:600, fontSize:13, opacity:saving?0.6:1 }}>{saving?'Saving...':'✅ Save Changes'}</button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="rcms-card">
        <div className="rcms-card-header"><span className="rcms-card-title">📂 Document Library ({docs.filter(d=>d.published).length} published)</span></div>
        {loading ? <div style={{ textAlign:'center', padding:32, color:'#B8B5AB', fontSize:13 }}>Loading...</div>
        : docs.length === 0 ? <div className="rcms-empty"><div className="rcms-empty-icon">📂</div><div className="rcms-empty-text">No documents yet!! Upload your first document above!!</div></div>
        : docs.map(d => (
          <div key={d.id} className="rcms-doc-row">
            <div className="rcms-doc-icon">{d.file_type?.includes('pdf')?'📕':d.file_type?.includes('image')?'🖼️':'📄'}</div>
            <div style={{ flex:1, minWidth:0 }}>
              <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:2, flexWrap:'wrap' }}>
                <span style={{ fontSize:13, fontWeight:600, color:'#0D1B3E' }}>{d.name}</span>
                <span className={d.published?'rcms-badge-pub':'rcms-badge-draft'}>{d.published?'Published':'Draft'}</span>
                <span style={{ fontSize:10, color:'#B8B5AB', background:'#F0EEE8', padding:'1px 6px', borderRadius:8 }}>{d.category}</span>
              </div>
              {d.description && <div style={{ fontSize:11, color:'#7A7870' }}>{d.description}</div>}
              <a href={d.file_url} target="_blank" rel="noreferrer" style={{ fontSize:10, color:'#9A7A30', textDecoration:'none' }}>🔗 View file</a>
            </div>
            <div style={{ display:'flex', gap:4, flexShrink:0 }}>
              <button className="rcms-btn-icon" onClick={() => togglePublished(d)}>{d.published?'👁️':'🙈'}</button>
              <button className="rcms-btn-icon" onClick={() => {setEditing(d);setForm({name:d.name,description:d.description||'',category:d.category||'Notarial Certificates',sort_order:d.sort_order||0,published:d.published})}}>✏️</button>
              <button className="rcms-btn-icon" onClick={() => deleteDoc(d)} style={{ color:'#E24B4A' }}>🗑️</button>
            </div>
          </div>
        ))}
      </div>
    </>
  )
}

// ── MAIN ──────────────────────────────────────────────────────
export default function ResourcesCMS() {
  const [tab, setTab] = useState('glossary')
  return (
    <>
      <style>{CMS_STYLES}</style>
      <div style={{ background:'linear-gradient(135deg,#0D1B3E,#1A3A5E)', borderRadius:16, padding:'24px 28px', marginBottom:24, color:'#fff' }}>
        <div style={{ fontFamily:'Cormorant Garamond,serif', fontSize:26, fontWeight:600, color:'#C9A84C', marginBottom:6 }}>📚 Resources CMS</div>
        <div style={{ fontSize:13, color:'rgba(255,255,255,0.7)', lineHeight:1.6 }}>You are in full control!! Manage glossary terms, training chapters, state links, and upload documents — all goes live instantly for your tribe!!</div>
      </div>
      <div className="rcms-tabs">
        <button className={`rcms-tab${tab==='glossary'?' active':''}`} onClick={() => setTab('glossary')}>📖 Glossary</button>
        <button className={`rcms-tab${tab==='manual'?' active':''}`} onClick={() => setTab('manual')}>📋 Training Manual</button>
        <button className={`rcms-tab${tab==='states'?' active':''}`} onClick={() => setTab('states')}>🗺️ State Resources</button>
        <button className={`rcms-tab${tab==='library'?' active':''}`} onClick={() => setTab('library')}>📂 Document Library</button>
      </div>
      {tab==='glossary' && <GlossaryTab />}
      {tab==='manual'   && <TrainingManualTab />}
      {tab==='states'   && <StateResourcesTab />}
      {tab==='library'  && <DocumentLibraryTab />}
    </>
  )
}
